export const adoptableText = (
  <>
    <h2>Adoptable Terms and Conditions</h2>
    <ul>
      <li>
        I will retain copyright to the artwork and may use it for my portfolio or promotional
        purposes
      </li>
      <li>
        Adoptable purchases are to be paid in full up front, I will send an invoice through PayPal
        (Or bought via Ko-Fi)
      </li>
      <li>
        You may resell the design, but not for more than the original price (unless sold with other
        art) and you can gift it. If you do resell or gift the design, please advise me of the new
        owner so I can note who is allowed to use the design
      </li>
      <li>
        Once paid I will email you a full resolution un-watermarked or signed version of the design
        (Or will be downloadable from Ko-Fi if purchased there)
      </li>
      <li>Adoptables cannot be refunded</li>
    </ul>
    <h2>Usage</h2>
    <ul>
      <li>
        Once the adoptable has been purchased the character belongs to you, you can make any changes
        to the design but please do not alter the original file
      </li>
      <li>
        Adoptables may not be used for any hateful, racist, homophobic, transphobic or any illegal
        or offensive material
      </li>
      <li>
        Please continue to credit me for the design/original art when used. Please credit to my
        Twitter @HelenAimee1 or through to my website: www.helenaimee.art
      </li>
    </ul>
  </>
);
